/** Auth portal sol kolon — landing ile aynı kart stili, tıklanamaz (fake) */
export const AUTH_CAPABILITY_CARDS = [
  { label: 'ProSorgu', desc: 'Parsel ve bölge sorgularını profesyonelce yapın.', icon: 'prosorgu' },
  { label: 'Basit Sorgu', desc: 'Hızlı ve kolay parsel sorgulama aracı.', icon: 'search' },
  { label: '3D Model', desc: 'Araziyi 3D ortamda inceleyin.', icon: 'cube' },
  { label: 'Hisseli Parsel', desc: 'Hisseli parselleri analiz edin.', icon: 'split' },
  { label: 'AI Drone', desc: 'Yapay zeka destekli drone görüntü analizi.', icon: 'drone' },
  { label: 'Mahalle Analizi', desc: 'Demografik ve yatırım verileri.', icon: 'chart' },
  { label: 'Satış Gridleri', desc: 'Bölgesel fiyat ve satış yoğunluğu analizi.', icon: 'grid' },
  { label: 'AI Video', desc: 'Arazi videolarını otomatik oluşturun.', icon: 'video' },
];
